import React from 'react';
import Label from './Label';
import { FormLabel } from '@blockstack/ui';
import Input from './Input';
// @ts-ignore
import Slider from 'rc-slider/lib/Slider';
// @ts-ignore
import 'rc-slider/assets/index.css';

interface Props {
    label: string;
    firstInputValue: number;
    secondInputValue: number;
    onFirstInputChange: (value: number) => void;
    onSecondInputChange: (value: number) => void;
    primaryInputCurrency: string;
    secondaryInputCurrency: string;
    min: number;
    max: number;
    ExtraInput?: React.Component;
    tooltip?: string;
    maxLength?: number;
}

export const CurrencyInputs: React.FC<Props> = (props: Props) => {
    const {
        label,
        min,
        max,
        tooltip,
        maxLength,
        firstInputValue,
        secondInputValue,
        onFirstInputChange,
        onSecondInputChange,
        primaryInputCurrency,
        secondaryInputCurrency,
    } = props;

    const onChange = (inputName: string, value: number) => {
        if (inputName === 'first') {
            // setFirstInputValue(value);
            onFirstInputChange(value);
        } else {
            // setSecondInputValue(value);
            onSecondInputChange(value);
        }
    };

    const onSliderChange = (value: number) => {
        console.log(firstInputValue, value);
        // setFirstInputValue(value);
        onFirstInputChange(value);
    };

    return (
        <div>
            <div>
                <FormLabel fontWeight="bold" mb="8px">
                    {tooltip && <Label label={label} tooltip={tooltip} />}
                </FormLabel>
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
                <div
                    style={{
                        width: '100%',
                        marginRight: '30px',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <div style={{ display: 'flex' }}>
                        <div style={{ marginRight: '15px' }}>
                            <Input
                                value={firstInputValue}
                                min={min}
                                max={max}
                                step={100000}
                                maxLength={maxLength}
                                onChange={(value: number) => onChange('first', value)}
                                currencyLabel={primaryInputCurrency}
                            />
                        </div>
                        <div>
                            <Input
                                value={secondInputValue}
                                min={min}
                                max={max}
                                step={100}
                                maxLength={maxLength}
                                onChange={(value: number) => onChange('second', value)}
                                currencyLabel={secondaryInputCurrency}
                            />
                        </div>
                    </div>
                    <Slider
                        {...props}
                        onChange={onSliderChange}
                        value={firstInputValue}
                        step={10000}
                        trackStyle={{ backgroundColor: '#3700ff' }}
                        tabIndex={-1} // Fix https://github.com/react-component/slider/issues/433
                        handleStyle={{ height: '20px', width: '20px', marginTop: '-8px', borderColor: '#E1E3E8' }}
                    />
                </div>
            </div>
        </div>
    );
};

export default CurrencyInputs;
